import { render } from "./UserComponent.vue?vue&type=template&id=14444e7e"
import script from "./UserComponent.vue?vue&type=script&lang=js"
export * from "./UserComponent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\laragon\\www\\activa-nexus-contacto\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__